import React, { ReactNode, ReactNodeArray } from "react";
import { AdContainer } from "./AdContainer";
import { AdTypes } from "./interfaces";

import "./styles.scss";

interface AdWrapperProps {
    type: AdTypes[];
    children?: ReactNodeArray | ReactNode;
}

export const AdWrapper = ({ type, children }: AdWrapperProps) => {
    return (
        <div className="flexWrapper">
            <div>{children}</div>
            <AdContainer type={type} />
        </div>
    );
};
